// src/app/services/api-call.service.ts
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../Environments/environments';
import { AppSwal } from './alertService';


@Injectable({
  providedIn: 'root'
})
export class ApiCallService {

  constructor(private httpClient: HttpClient) { }
  token:string|null = null;
  checkTockExpiry(){
    this.token = sessionStorage.getItem("authToken");
    if(this.token === null){
      AppSwal.fire({
        icon:'info',
        title:'Session Expired',
        text:'Please login again your session is expired'
      });
      return;
    }
  }

  // GET request
  fetchData<T>(controller: string, action: string, jdata?: Record<string, any>) {
    let params = new HttpParams();
    if (jdata) {
      Object.keys(jdata).forEach(key => {
        params = params.set(key, jdata[key]);
      });
    }
    return this.httpClient.get<T>(`${environment.apiUrl}/${controller}/${action}`, { params });
  }
  postExcelFile(controller: string, action: string, formData: FormData) {
      return this.httpClient.post(
      `${environment.apiUrl}/${controller}/${action}`,
        formData
      );
    }


  // fetchData<T>(controller: string, action: string, jdata?: Record<string, any>, method: 'GET' | 'POST' = 'GET') {
  //   const url = `${environment.apiUrl}/${controller}/${action}`;

  //   if (method === 'POST') {
  //     return this.httpClient.post<T>(url, jdata);
  //   } else {
  //     let params = new HttpParams();
  //     if (jdata) {
  //       Object.keys(jdata).forEach(key => {
  //         params = params.set(key, jdata[key]);
  //       });
  //     }
  //     return this.httpClient.get<T>(url, { params });
  //   }
  // }
  // ✅ POST request (new)
  // postData<T>(controller: string, action: string, body: any) {
  //   return this.httpClient.post<T>(`${environment.apiUrl}/${controller}/${action}`, body);
  // }
postData<T>(controller: string, action: string, body: any) {
  return this.httpClient.post<T>(
    `${environment.apiUrl}/${controller}/${action}`,
    body,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}

  // PUT request
  putData<T>(controller: string, action: string, body: any) {
    return this.httpClient.put<T>(`${environment.apiUrl}/${controller}/${action}`, body);
  }
  postFormData<T>(controller: string, action: string, formData: FormData) {
    return this.httpClient.post<T>(`${environment.apiUrl}/${controller}/${action}`, formData, {
      reportProgress: true,
      observe: 'body'
    });
  }


  // DELETE request
  deleteData<T>(controller: string, action: string, jdata?: Record<string, any>) {
    let params = new HttpParams();
    if (jdata) {
      Object.keys(jdata).forEach(key => {
        params = params.set(key, jdata[key]);
      });
    }
    return this.httpClient.delete<T>(`${environment.apiUrl}/${controller}/${action}`, { params });
  }
}
